import { graphql } from 'react-relay/legacy';

const questionRootQuery = graphql`
    query questionRootQuery($urlLabel: String!) {
        viewer {
            ...questionLayout_viewer
            singleQuestion(urlLabel: $urlLabel) {
                url
                title
                answerCount
                microdata
                answers {
                    text
                }
                relatedQuestionItems {
                    edges {
                        node {
                            item {
                                productPhotos: photos(limit: 1) {
                                    smallPath
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export { questionRootQuery };
